import React from 'react';
import { Routes, Route } from "react-router-dom";
import Header from './Components/Header';
import Main from './Components/Main';
import ReportMain from './Components/Report/ReportMain';
import QuestionMain from './Components/Question/QuestionMain';
import MailboxMain from './Components/Mailbox/MailboxMain';
import './styles/responsive.css'
import Footer from './Components/footer';
import Login from './Components/Mailbox/mailboxcontent2'
import ViewReports from './Components/ViewReports';
import ReportInner from './Components/ReportInner';
import store from "./lib/redux/Store";
import { PrivateRoutes } from "./lib/hoc/PrivateRoutes";
import { Provider } from 'react-redux';
import { useSelector, useDispatch } from 'react-redux';
import Register from './Components/Register';
import LegalDocuments from './Components/LegalDocuments';
import FAQ from './Components/FAQ';



const App = () => {
  return (
    <Provider store={store}>
      <Header />
      <Routes>
        {/* Default route */}
        <Route path="/" element={<Main />} />
        {/* Route for the Report1 page */}
        <Route path="/ReportMain" element={<ReportMain />} />
        <Route path="/QuestionMain" element={<PrivateRoutes><QuestionMain /></PrivateRoutes>} />
        <Route path="/MailboxMain" element={<MailboxMain />} />
        <Route path="/Login" element={<Login />} />
        <Route path="/Register" element={<Register/>} />
        <Route path="/ViewReports" element={<PrivateRoutes><ViewReports /></PrivateRoutes>} />
        <Route path="/ReportInner" element={<PrivateRoutes><ReportInner /></PrivateRoutes>} />
        <Route path="/LegalDocuments" element={<LegalDocuments />} />
        <Route path="/FAQ" element={<FAQ/>} />
      </Routes>
      <Footer/>
    </Provider>
  );
};

export default App;
